import type { SVGComponentProps } from 'BreetHelpers';

export const PlusIcon = ({ ...rest }: SVGComponentProps) => (
	<svg
		width='17'
		height='24'
		viewBox='0 0 17 24'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...rest}
	>
		<path
			d='M14.5 12C14.5 12.1326 14.4473 12.2598 14.3536 12.3536C14.2598 12.4473 14.1326 12.5 14 12.5H9V17.5C9 17.6326 8.94732 17.7598 8.85355 17.8536C8.75979 17.9473 8.63261 18 8.5 18C8.36739 18 8.24021 17.9473 8.14645 17.8536C8.05268 17.7598 8 17.6326 8 17.5V12.5H3C2.86739 12.5 2.74021 12.4473 2.64645 12.3536C2.55268 12.2598 2.5 12.1326 2.5 12C2.5 11.8674 2.55268 11.7402 2.64645 11.6464C2.74021 11.5527 2.86739 11.5 3 11.5H8V6.5C8 6.36739 8.05268 6.24021 8.14645 6.14645C8.24021 6.05268 8.36739 6 8.5 6C8.63261 6 8.75979 6.05268 8.85355 6.14645C8.94732 6.24021 9 6.36739 9 6.5V11.5H14C14.1326 11.5 14.2598 11.5527 14.3536 11.6464C14.4473 11.7402 14.5 11.8674 14.5 12Z'
			fill='#05A2BF'
		/>
	</svg>
);
